import Rx from 'rx';

export default function businessDays($wamp) {

  const days = new Rx.ReplaySubject();

  $wamp.call('org.eggs.get_business_days', [])
    .then(function (r) {
    days.onNext(r.args);
  });

  return days;
}

